module.exports = __webpack_public_path__ + "static/media/Cube3_in.9365283f.jpg";